<template>
    <div class="content">
        <div class="b_img"></div>
        <ul v-for="item in dataJson" v-if="item.datas">
            <li>
                <h3 class="title">{{item.name}}</h3>
                <template v-if="item.dataType=='table'" v-for="itemdatas in item.datas">
                    <h4 class="subName" v-if="itemdatas.titleName">{{itemdatas.titleName}}</h4>
                    <!-- <table>
                            <thead>
                                <tr>
                                    <th v-for="th in itemdatas.th">{{th.tableHead}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(tdInfo,index) in itemdatas.td">
                                    <td v-for="val in tdInfo">{{val}}</td>
                                </tr>
                            </tbody>
                        </table> -->
                    <el-table :data="itemdatas.td">
                        <template v-for="tabledata in itemdatas.tabledata">
                            <el-table-column :prop="tabledata.tdName" :label="tabledata.tableHead" :min-width="tabledata.tableHead=='说明'?250:' '" align="center">
                            </el-table-column>
                        </template>
                    </el-table>
                </template>
                <div v-if="item.dataType=='text'">{{item.datas}}</div>
                <div v-if="item.dataType=='text_debugger'">{{item.datas}}<a class="linkA" @click="jumpDebugging(item)" href="javascript:;">调试该接口</a></div>
                <div v-if="item.dataType=='code'">
                    <slot :name="item.datas">
                        只有在没有要分发的内容时才会显示。
                    </slot>
                </div>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
  name: "",
  props: {
    Pdatas: {
      type: Object
    }
  },
  data() {
    return {
      dataJson: [
        { name: "业务说明", datas: this.Pdatas.explain, dataType: "text" },
        {
          name: "请求地址(测试环境)",
          datas: this.Pdatas.t_url,
          dataType: "text"
        },
        // { name: "生产环境服务地址", datas: this.Pdatas.p_url, dataType: 'text' },
        { name: "前置条件", datas: this.Pdatas.precondition, dataType: "text" },
        { name: "适用系统", datas: this.Pdatas.fitSystem, dataType: "text" },
        { name: "调用方式", datas: this.Pdatas.pattern, dataType: "text" },
        {
          name: "请求参数说明",
          datas: this.Pdatas.Q_params,
          dataType: "table"
        },
        { name: "请求参数示例", datas: "q_code", dataType: "code" },
        {
          name: "响应参数说明",
          datas: this.Pdatas.R_params,
          dataType: "table"
        },
        { name: "响应参数示例", datas: "r_code", dataType: "code" }
      ],
      othersData: [],
      explainWidth: 200
    };
  },
  methods: {
    jumpDebugging(param) {
      console.info("=========="+param.datas);
      let params = {
        url: param.datas,
        body: $("pre")
          .eq(0)
          .html()
      };
      window.localStorage.setItem(
        "DebuggingTools_params",
        JSON.stringify(params)
      );
      window.open("/DebuggingTools");
      // this.$router.push({ name: 'DebuggingTools', params: { url: param.datas, body: $("pre").eq(0).html() }})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.content {
  font-size: 14px;
  h3 {
    font-size: 16px; // margin: 20px 0 10px 0;
  }
  ul {
    padding: 5px 10px;
    padding: 5px 5px 20px 0;

    li {
      text-align: left;
      div {
        margin-top: 5px;
      }
    }
  }
  .linkA {
    color: #20a0ff;
    // text-decoration: underline #20a0ff;
    &:hover {
      color: #117ecc;
      //   text-decoration: none;
    }
  }
}

.subName {
  padding: 15px 0 0px 0px;
  max-width: 90%;
  min-width: 80%;
  color: #333;
}

table {
  display: table;
  max-width: 90%;
  min-width: 80%;
  border-collapse: collapse;
  border-spacing: 0;
  overflow: auto;
  border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
  background-color: #f6f8f9;
}

table tr:first-child {
  border: none;
}

table tr {
  border-top: 1px solid #e7e7eb;
}

table th {
  font-weight: 400;
  color: #8d8d8d;
  text-align: left;
  height: 40px;
  padding: 6px 12px;
  white-space: nowrap;
  border: none;
}

table td {
  // height: 35px;
  padding: 15px 12px;
  text-align: justify;
}

pre {
  background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/components/extendCommonStructure.vue